module.exports = __webpack_public_path__ + "img/knowledge-B.a76c236c.svg";